import axios from "axios";

export const modelApi = axios.create({
  // 프록시를 사용하므로 상대 경로 사용
  baseURL:
    process.env.REACT_APP_NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_MODEL
      : "",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
